export const bizCode = (code) => {
  switch (code) {
    case 1:
    case "1":
      return "R&D";
    case 2:
    case "2":
      return "생산품질";
    case 3:
    case "3":
      return "영업";
    case 4:
    case "4":
      return "마케팅";
    default:
      return "STAFF";
  }
};

export const careerName = {
  1: "경력",
  2: "신입",
  3: "인턴",
  4: "신입/경력",
};
